var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content",attrs:{"id":"content"}},[(_vm.$root.isLoading)?_c('progress-bar'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }